import React from "react";
import { Link } from "react-router-dom";
import Horizontalstepper from "./horizontal-stepper";

export default function SurveyFlowHeader({
  flow,
  activeStep,
  isAuthenticated,
  maxStepReached,
  onNavigate,
  onLogoClick,
  rightSlot = null,
}) {
  return (
    <div className="survey-flow-header">
      <Link to="/" className="survey-flow-header__logo" onClick={onLogoClick}>
        <img
          src="/json-media/img/logo.svg"
          alt="GI"
          width={50}
          style={{ padding: 5 }}
        />
      </Link>

      <Horizontalstepper
        flow={flow}
        activeStep={activeStep}
        isAuthenticated={isAuthenticated}
        maxStepReached={maxStepReached}
        onNavigate={onNavigate}
      />

      <div className="survey-flow-header__right">{rightSlot}</div>
    </div>
  );
}